import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAppContainerId, selectRegion } from "../store/orderingSlice";

export function useListener(target, event_name, listener) {
    useEffect(
      () => {
        target.addEventListener(event_name, listener);
        const cleanup = () => {
          target.removeEventListener(event_name, listener);
        }
        return cleanup;
      },
      // eslint-disable-next-line
      [] // empty dependencies array so effect function only runs on mount and unmount
    );
  }

export const useUniqueModuleReadableId = () => {
	const appContainerId = useSelector(selectAppContainerId);
	return (readable_id) => {
		return readable_id + '_' + appContainerId;
	};
};

export const useFormatRegionPrice = () => {
	const region = useSelector(selectRegion);
	return (price_text) => {
    switch (region) {
      case 'EU':
        return price_text.toFixed(2) + " €";
      default:
        return "$" + price_text.toFixed(2)
    }
	};
};